import OLWebGLVectorLayer from 'ol/layer/WebGLVector.js';
import VectorSource from 'ol/source/Vector.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import WebGLVectorLayerRenderer from '../renderer/webgl/VectorLayer.js';

class WebGLVectorLayer extends OLWebGLVectorLayer {
    constructor(options = {}) {
        const source = options.source || new VectorSource({
            url: options.url || 'data.geojson',
            format: new GeoJSON()
        });

        super({
            source,
            style: options.style,
            variables: options.variables,
            disableHitDetection: options.disableHitDetection,
            filter: options.filter,
            ...options
        });

    }

    createRenderer() {
        return new WebGLVectorLayerRenderer(this, {
            style: this.style_,
            variables: this.styleVariables_,
            disableHitDetection: this.hitDetectionDisabled_
        });
    }
}

export default WebGLVectorLayer;
